// extracted by mini-css-extract-plugin
export var columnList = "_eg-0";